import React from "react";
import TitleStripe from "../../common/TitleStripe";
import { Alert, Button } from "flowbite-react";
import PdfViewer from "../../common/query/PdfViewer";

const CodigoSegurancaCRV = ({ data }) => {
  return (
    <div>
      <TitleStripe>Código Segurança crv</TitleStripe>
      {data?.codigoSegurancaCRV?.statusRetorno == 1 ? (
        <>
          <div className="grid grid-cols-2 gap-2 mt-4">
            <div>
              <span className="font-semibold inline-block mr-1">Placa:</span>
              {data?.codigoSegurancaCRV?.placa}
            </div>
            <div>
              <span className="font-semibold inline-block mr-1">Chassi:</span>
              {data?.codigoSegurancaCRV?.chassi}
            </div>
            <div>
              <span className="font-semibold inline-block mr-1">Renavam:</span>
              {data?.codigoSegurancaCRV?.renavam}
            </div>
            <div>
              <span className="font-semibold inline-block mr-1">
                Marca/Modelo:
              </span>
              {data?.codigoSegurancaCRV?.marcaModelo}
            </div>
            <div>
              <span className="font-semibold inline-block mr-1">
                Cidade/UF:
              </span>
              {data?.codigoSegurancaCRV?.cidade}/{data?.codigoSegurancaCRV?.uf}
            </div>
          </div>
          {data?.codigoSegurancaCRV?.urlDownload && (
            <div className="mt-10">
              <PdfViewer
                url={data?.codigoSegurancaCRV?.urlDownload}
                message="Carregando visualização do Código de Segurança CRV..."
              />
              <div className="mt-5 text-center flex justify-center">
                <a
                  className="bg-primary rounded-md px-4 py-2 text-white mt-2"
                  href={`${data?.codigoSegurancaCRV?.urlDownload}`}
                  target="_blank"
                >
                  Baixar Código de Segurança CRV em PDF
                </a>
              </div>
            </div>
          )}
        </>
      ) : (
        <Alert withBorderAccent color="gray" className="mt-5">
          Consulta Indisponível no momento
        </Alert>
      )}
    </div>
  );
};

export default CodigoSegurancaCRV;
